import Head from "next/head";
import Breadcrumb from "react-bootstrap/Breadcrumb";
import React, { useEffect, useState } from "react";
import { Button, Form, Modal } from "react-bootstrap";
import Slider from "react-slick";
import { useRouter } from "next/router";
import cookie from "js-cookie";
import axios from "axios";
import { getIntouch, requestCallback } from "../../../api.services.js/others";
import config from "../../../config";
import { ImageList } from "../../../src/components/design-pages/imageList";

const tileData = [
  {
    image:
      "https://images.orientbell.com/media/design-images/White - 21/300X450 ODG Statuario White_ODH Arrow Grey HL.webp",
    alt: "White-bathroom design with white sink and mirror",
    title: "White-bathroom design with white sink and mirror",
  },
  {
    image:
      "https://images.orientbell.com/media/design-images/White - 21/300x600 SDH SIGMA MULTI HL, SDG SIGMA GRIS & SDG SIGMA SILVER.webp",
    alt: "Stylish white-bathroom design with grey sink,white bathtub",
    title: "Stylish white-bathroom design with grey sink,white bathtub",
  },
  {
    image:
      "https://images.orientbell.com/media/design-images/White - 21/GFT Lina Starwhite & ODH Kolam Brown HL_300x600 mm.webp",
    alt: "Stylish white-bathroom design using balck hair wash basin",
    title: "Stylish white-bathroom design using balck hair wash basin",
  },
  {
    image:
      "https://images.orientbell.com/media/design-images/White - 21/Linea Statuario Gold Vein & Carving Endless Statuario Gold Vein_600x1200 mm.webp",
    alt: "Linea Statuario Gold Vein and Carving Endless Design",
    title:
      "Luxurious white-bathroom design with white sink, shelf, oval-shaped mirror",
  },
  {
    image:
      "https://images.orientbell.com/media/design-images/White - 21/ODG Lily Grey, ODH Lily Top HL & ODH Lily Bottom HL_Bathroom Ambiance_Ceramic Wall Tiles_300x450 MM.webp",
    alt: "Sleek white bathroom design with Lily Grey ceramic wall tiles",
    title: "Sleek white bathroom design with Lily Grey ceramic wall tiles",
  },
  {
    image:
      "https://images.orientbell.com/media/design-images/White - 21/ODG Onyx White & OHG Multi Mosaic Moroccan Art HL_300x450 mm.webp",
    alt: "White-bathroom design with white bathtub, sink, large window",
    title: "White-bathroom design with white bathtub, sink, large window",
  },
  {
    image:
      "https://images.orientbell.com/media/design-images/White - 21/ODG Statuario Bianco, ODH statuario Tulip HL_Bathroom Ambiance_Ceramic Wall Tiles_300X600 MM.webp",
    alt: "Modern white-bathroom design with white bathtub, round shape shower",
    title:
      "Modern white-bathroom design with white bathtub, round shape shower",
  },
  {
    image:
      "https://images.orientbell.com/media/design-images/White - 21/ODH CASSIO LINE HL, ODM CASSIO GREY DK & ODM CASSIO GREY LT_Bathroom Ambiance_Ceramic Wall Tiles_300X600 MM_2.webp",
    alt: "Cassio Line and Cassio Grey Bathroom Ambiance Design",
    title:
      "White-bathroom design with grey wall tiles, black & white sink, Bathtub and mirror",
  },
  {
    image:
      "https://images.orientbell.com/media/design-images/White - 21/ODH JORDY HL, ODG JORDY GREY LIGHT & GREY DARK_300x600 mm.webp",
    alt: "Stylish white-bathroom design with round mirror, pedestal washbasin",
    title:
      "Stylish white-bathroom design with round mirror, pedestal washbasin",
  },
  {
    image:
      "https://images.orientbell.com/media/design-images/White - 21/ODH Leaves Flora HL, ODG Leaves Grey DK & ODG Leaves Grey LT_Bathroom Ambiance_Ceramic Wall Tiles_300x600 MM.webp",
    alt: "Classic white-bathroom design with sink, square mirror, towel",
    title: "Classic white-bathroom design with sink, square mirror, towel",
  },
  {
    image:
      "https://images.orientbell.com/media/design-images/White - 21/ODH VANITO NERO HL, ODG VANITO NERO DK & ODG VANITO NERO DK_Bathroom Ambiance_Ceramic Wall Tiles_300x450 MM.webp",
    alt: "Vanito nero white-bathroom design with sink, square mirror, towel",
    title: "Vanito nero white-bathroom design with sink, square mirror, towel",
  },
  {
    image:
      "https://images.orientbell.com/media/design-images/White - 21/OHG Multi Mosaic Moroccan Art HL & ODG Onyx White_300x450 mm.webp",
    alt: "White bathroom design with round mirror, shelf, table  and a grey sink",
    title:
      "White bathroom design with round mirror, shelf, table  and a grey sink",
  },
  {
    image:
      "https://images.orientbell.com/media/design-images/White - 21/PGVT Brown Streak Bianco & Rocker Grafton Brown_Bathroom_Glazed Vitrified Tile_Floor & Wall Tile Ambience_600x1200 MM.webp",
    alt: "White-bathroom design with with cabinet, round mirror, bathtub",
    title: "White-bathroom design with with cabinet, round mirror, bathtub",
  },
  {
    image:
      "https://images.orientbell.com/media/design-images/White - 21/SBG Black White Popsicle & SFM Black White Popsicle_300x450 mm.webp",
    alt: "white bathroom design with white bathtub, washbasin with cabinet and a round mirror",
    title:
      "white bathroom design with white bathtub, washbasin with cabinet and a round mirror",
  },
  {
    image:
      "https://images.orientbell.com/media/design-images/White - 21/SHG Knroll Skeleton Leaves HL, SBG Grey Knroll Brick, SBG Nero Knroll Brick & SFM Nero Knroll Brick_300x450 mm.webp",
    alt: "Stylish white-bathroom design with plant bouquet, mirror, black sink",
    title:
      "Stylish white-bathroom design with plant bouquet, mirror, black sink",
  },
  {
    image:
      "https://images.orientbell.com/media/design-images/White - 21/SHG Black White Swirl Mosaic HL, SBG Makrana Marble & SFM Makrana Marble_300x450 mm.webp",
    alt: "white-bathroom design with oval-shaped mirror, white sink with cabinet, round shower",
    title:
      "white-bathroom design with oval-shaped mirror, white sink with cabinet, round shower",
  },
  {
    image:
      "https://images.orientbell.com/media/design-images/White - 21/SHG MOSAIC BLACK WHITE HL, SBG MOSAIC BLACK & SBG MOSAIC WHITE _300x450mm.webp",
    alt: " white-bathroom design with large window, round shower, table, rectangular mirror",
    title:
      " white-bathroom design with large window, round shower, table, rectangular mirror",
  },
  {
    image:
      "https://images.orientbell.com/media/design-images/White - 21/SHG MULBERRY CHIPS HL, SBG CHIPS GREY DK, SBG CHIPS GREY LT & SFM CHIPS GREY DK _300x450mm.webp",
    alt: "Modern white-bathroom design with double white sink, round shower, square mirror",
    title:
      "Modern white-bathroom design with double white sink, round shower, square mirror",
  },
  {
    image:
      "https://images.orientbell.com/media/design-images/White - 21/SHG Statuario Flower Multi HL & SBG Statuario Vein Marble_300x450 mm.webp",
    alt: "Stylish white-bathroom design with vein marble pattern tiles, over counter wash Basin",
    title:
      "Stylish white-bathroom design with vein marble pattern tiles, over counter wash Basin",
  },
  {
    image:
      "https://images.orientbell.com/media/design-images/White - 21/SPH Frame Golden Veins HL, SPB Golden Veins White Marble & Black Marble.webp",
    alt: "White-bathroom design with black and white tiles combination",
    title: "White-bathroom design with black and white tiles combination",
  },
];

const settings = {
  infinite: true,
  slidesToShow: 4,
  slidesToScroll: 1,
  autoplay: true,
  centerMode: false,
  autoplaySpeed: 3000,
  arrows: true,
  dots: false,
  centerPadding: "0px",
  responsive: [
    {
      breakpoint: 991,
      settings: {
        arrows: true,
        centerMode: false,
        slidesToShow: 3,
      },
    },
    {
      breakpoint: 768,
      settings: {
        arrows: true,
        centerMode: false,
        slidesToShow: 2,
      },
    },
    {
      breakpoint: 641,
      settings: {
        arrows: true,
        centerMode: false,
        slidesToShow: 1,
      },
    },
  ],
};
const faqs = [
  {
    question: "What aspects should I consider while planning a bathroom?",
    answer:
      "Consider the available area, the desired overall style, ventilation, lighting, storage needs, and ventilation. Do not forget to infuse your flair into the design as well but give priority to functionality also.",
  },
  {
    question: "Can a small bathroom be made to appear bigger?",
    answer:
      "Yes, you can make a small bathroom look bigger with a few smart design choices. Using light colours like white or soft pastels can create an open feel. Large mirrors can reflect light and give an illusion of space. Opt for large tiles with fewer grout lines and install proper lighting. Keeping the décor minimal and using wall-mounted fixtures also helps to make the room feel more spacious.",
  },
  {
    question: "What are some of the recent trends in bathroom decor?",
    answer:
      "Popular trends in bathroom décor focus on creating a spa-inspired ambiance with neutral tones, natural elements, and soft lighting. Patterned or textured wall tiles paired with stylish flooring and well-placed mirrors are commonly seen. Additionally, glossy marble tiles for walls combined with matte finish tiles for floors and metallic décor elements, have become popular choices, offering a mix of elegance and contemporary style.",
  },
  {
    question: "How to select the best flooring for my bathroom?",
    answer:
      "Select flooring materials that offer resistance against moisture, such as vitrified tiles or ceramic tiles. Orientbell Tiles has a collection of anti-skid tiles that will be ideal for a bathroom. Along with the practical side, consider your design choices, maintenance requirements, and budget.",
  },
  {
    question: "Which type of lighting works the best in a bathroom?",
    answer:
      "You can go ahead with the combination of ambient, and accent lighting to make a bathroom seem cosy and well-lit. ",
  },
  {
    question:
      "Is it better to work with an expert designer or can I design my own bathroom?",
    answer:
      "Hiring a designing expert brings experience, saves time, and brings a consistent style. However, if you are on a tight budget, creating your bathroom design is achievable with careful planning and study.",
  },
];

const text = `White bathroom designs are timeless and versatile. Every white bathroom design offers a clean and bright atmosphere. The colour white evokes a sense of calmness and purity. Its peacefulness crafts a serene retreat away from the outdoor world. The soft glow of whites surrounds you in a peaceful ambience, transforming your bathroom into a unique sanctuary for relaxation and self-care. To create a stylish white bathroom design, you must infuse different elements, like decor tiles, tubs, and fixtures. Each component comes together to make the room feel elegant and comforting. Here, we have diverse white bathroom inspirations for you to create an ageless and calming white bathroom. Pick a design that suits your lifestyle the most and create a quiet escape from the chaos of everyday life.`;

function WhiteBathroom() {
  const router = useRouter();
  const [isExpertTalkClicked, setIsExpertTalkClicked] = useState(false);
  const [activeIndex, setActiveIndex] = useState(null);
  const [relatedBlogData, setRelatedBlogData] = useState([]);
  const [isReadMore, setIsReadMore] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [showAll, setShowAll] = useState(false);
  useEffect(() => {
    getRelatedBlogs();
  }, []);

  const toggleReadMore = () => {
    setIsReadMore(!isReadMore);
  };

  const maxChars = 300;
  const previewText = text.substring(0, maxChars);
  const remainingText = text.substring(maxChars);
  var requestOptions = {
    method: "GET",
  };
  const getRelatedBlogs = async () => {
    // try{

    fetch(
      `${config.HEADLESS_BASE_URL}/blog/wp-json/post/v2/category/term=bathroom-designs`,
      requestOptions
    )
      .then((response) => response.text())
      .then((result) => {
        setRelatedBlogData(JSON.parse(result));
      })
      .catch((error) => console.log("error", error));
  };
  const handleToggle = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  const displayedFAQs = showAll ? faqs : faqs.slice(0, 5);
  return (
    <>
      <Head>
        <title>Modern White Bathroom Design Ideas | Orientbell </title>
        <meta
          name="title"
          content="Modern White Bathroom Design Ideas | Orientbell"
        />
        <meta
          name="description"
          content="Discover stunning modern white bathroom design ideas with Orientbell. Explore sleek, minimalist styles, innovative layouts, and premium tile solutions to create a serene, elegant, and functional bathroom space."
        />
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              "@context": "https://schema.org",
              "@type": "BreadcrumbList",
              itemListElement: [
                {
                  "@type": "ListItem",
                  position: 1,
                  name: "Home",
                  item: "https://www.orientbell.com/",
                },
                {
                  "@type": "ListItem",
                  position: 2,
                  name: "Design Ideas",
                  item: "https://www.orientbell.com/design-ideas/",
                },
                {
                  "@type": "ListItem",
                  position: 3,
                  name: "Bathroom Designs",
                  item: "https://www.orientbell.com/design-ideas/bathroom-designs/",
                },
                {
                  "@type": "ListItem",
                  Position: 4,
                  name: "White Bathroom",
                  item: "https://www.orientbell.com/design-ideas/bathroom-designs/white-bathroom ",
                },
              ],
            }),
          }}
        ></script>

        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              "@context": "https://schema.org",
              "@type": "WebPage",
              url: "design-ideas/bathroom-designs/white-bathroom",
              headline: "",
              breadcrumb:
                "Home > Design Ideas > Bathroom Designs > White Bathroom",
              name: "Modern White Bathroom Design Ideas | Orientbell",
              description:
                "Discover stunning modern white bathroom design ideas with Orientbell. Explore sleek, minimalist styles, innovative layouts, and premium tile solutions to create a serene, elegant, and functional bathroom space.",
            }),
          }}
        ></script>
      </Head>

      <div className="designpage-section">
        <div className="container">
          <Breadcrumb>
            <Breadcrumb.Item href="https://www.orientbell.com">
              Home
            </Breadcrumb.Item>
            <Breadcrumb.Item href="https://www.orientbell.com/design-ideas">
              Design Ideas
            </Breadcrumb.Item>
            <Breadcrumb.Item href="https://www.orientbell.com/design-ideas/bathroom-designs">
              Bathroom Designs
            </Breadcrumb.Item>
            <Breadcrumb.Item href="https://www.orientbell.com/design-ideas/bathroom-designs/white-bathroom">
              White Bathroom
            </Breadcrumb.Item>
          </Breadcrumb>

          <div className="designpage-heading-bx padding-spacing">
            <h4>Showing {tileData.length} results for </h4>
            <h1>White Bathroom Design</h1>
            <p className="description-text">
              {previewText}
              {!isReadMore && text.length > maxChars && "..."}
              {isReadMore && <span>{remainingText}</span>}
              {text.length > maxChars && (
                <button onClick={toggleReadMore}>
                  {isReadMore ? "Read Less" : "Read More"}
                </button>
              )}
            </p>
          </div>
          <div className="obl-master-design-section">
            <h2>White Bathroom Design Gallery</h2>
            <div className="designpage-category-row inner-design-gallery">
              <ImageList tileData={tileData} />
            </div>

            <div className="bottom-content">
              <div className="common-text-content-section">
                <h2>Modern White Bathroom Ideas</h2>
                <p>
                  {` Modern white bathrooms are admired for their clean, bright
                  appeal. After all, white is timeless and versatile, but how
                  can you make the most of it? Let's check out some
                  <strong> white bathroom ideas </strong>that can turn your
                  bathing space into a modern oasis.`}{" "}
                </p>
                <ul>
                  <li>
                    <h5>
                      <strong>Clean and Bright:</strong>
                    </h5>
                    <p>
                      White interior decor makes any bathroom feel larger and
                      brighter. This is particularly beneficial if you have
                      space limitations.{" "}
                    </p>
                  </li>
                  <li>
                    <h5>
                      <strong>Mix Materials:</strong>
                    </h5>
                    <p>
                      Combine different materials like ceramic and vitrified
                      tiles and wood. This adds texture and depth to any white
                      bathroom.
                    </p>
                  </li>
                  <li>
                    <h5>
                      <strong>Minimalist Design:</strong>
                    </h5>
                    <p>
                      Modern bathrooms often feature a simplistic design —
                      perfect for you if you prefer a clutter-free space. Clean
                      lines, simple fixtures, and elegant designs can give a
                      sleek look.{" "}
                    </p>
                  </li>
                  <li>
                    <h5>
                      <strong>Accent Features: </strong>
                    </h5>
                    <p>
                      Add some personality with decorative tiles, like floral,
                      geometric, and mosaic. They can add a pop of colour for a
                      big impact on the overall design.
                    </p>{" "}
                  </li>

                  <li>
                    <h5>
                      <strong> Statement Fixtures: </strong>{" "}
                    </h5>
                    Do not forget to pick modern fixtures for your bathroom
                    remodel project. Install modern faucets, sleek mirrors, and
                    even stylish shower heads.
                  </li>
                </ul>
              </div>

              <div className="common-text-content-section">
                <h2> How Do I Determine My Modern White Bathroom Layout? </h2>
                <p>
                  The layout of your modern white bathroom should be stylish and
                  functional. But how do you decide the best layout design
                  within the available space? Here are some important tips for
                  planning to create an efficient bathroom layout.
                </p>
                <ul>
                  <li>
                    <h5>
                      <strong>Understand Your Space:</strong>
                    </h5>
                    <p>
                      How big or small your bathroom is, is important to
                      planning the layout. Start by measuring the entire area,
                      and noting the placement of doors and windows. This helps
                      you determine what can fit and where.
                    </p>
                  </li>
                  <li>
                    <h5>
                      <strong>Follow Standard Regulations: </strong>
                    </h5>

                    <p>
                      {" "}
                      Keep in mind the required distances between fixtures for
                      safety and comfort. For example, try to keep the toilet at
                      least 15 inches from the centre of any other fixture.{" "}
                    </p>
                  </li>
                  <li>
                    <h5>
                      <strong>Use the Right Layout Style:</strong>
                    </h5>
                    <p>
                      {" "}
                      Would you prefer a linear bathroom layout? Or, do you like
                      a more open concept? A modern white bathroom layout can
                      include simple, straight lines. Along with that, you can
                      include a more creative tile arrangement that elevates the
                      overall design.
                    </p>{" "}
                  </li>

                  <li>
                    <h5>
                      <strong>Identify Your Needs: </strong>
                    </h5>
                    <p>
                      First, you should decide on what features and fixtures you
                      want to have in your bathroom. For example, a bathtub, a
                      shower, or both - what do you need in your bathroom? Or,
                      do you need a vanity or storage cabinet? Think about what
                      features will improve your lifestyle and bathing routines.{" "}
                    </p>
                  </li>

                  <li>
                    <h5>
                      <strong>Optimise the Flow:</strong>
                    </h5>
                    <p>
                      Consider creating a natural flow in the bathroom for a
                      calming effect. Avoid placing the toilet in an area that
                      feels cluttered or awkward. Make sure that there is
                      sufficient room to move between the bathtub, shower, and
                      vanity.
                    </p>
                  </li>
                </ul>
              </div>

              <div className="common-text-content-section">
                <h2>
                  What Materials Should I Add to My Modern White Bathroom
                  Design?
                </h2>
                <p>
                  The right materials can surely make all the difference in your
                  white bathroom. With so many options, how can you pick the
                  most appropriate materials? Here are some materials that you
                  can consider, along with their benefits and things to pick.{" "}
                </p>
                <ul>
                  <li>
                    <h5>
                      <strong>Tiles </strong>
                    </h5>
                    <p>
                      Every{" "}
                      <a href="https://www.orientbell.com/design-ideas/bathroom-designs/">
                        bathroom design
                      </a>{" "}
                      {`uses tiles since they are durable, water-resistant, and
                      easy to maintain. Also, they come in endless designs, from
                      sleek modern to classic patterns, even in white tones. So
                      why won't you use them in your white bathroom? Pick tiles
                      from ceramic and vitrified options that are long-lasting
                      and come in diverse designs. For modern and elegant
                      bathrooms, white walls and floor tiles can work
                      wonderfully. For example, you can use floral white wall
                      tiles and pair them with plain white tiles. Use the same
                      tile option on the floor. Or, combine multi-coloured
                      geometric wall tiles with marble tiles with subtle
                      veining. Also, don't you want to use unique wall patterns
                      to upgrade the appeal of modern bathrooms? Go for it!
                      Don't forget to pick anti-skid floor tiles for safe
                      bathroom flooring.`}
                    </p>
                  </li>
                  <li>
                    <h5>
                      <strong>Granite Tile Countertops: </strong>
                    </h5>

                    <p>
                      {" "}
                      Opt for granite tiles for your bathroom is countertop.
                      Their durable and non-porous nature can be a perfect
                      addition to the bathroom. From white to black - pick any
                      colour that suits your white bathroom is backsplash.{" "}
                    </p>
                  </li>
                  <li>
                    <h5>
                      <strong>Storage Cabinets: </strong>
                    </h5>
                    <p>
                      {" "}
                      For a modern white bathroom, you can pick a cabinet with a
                      sleek, matte finish. For example, you can go for wooden
                      cabinets to add warmth and texture. Or, do you prefer a
                      floating vanity to make the bathroom feel more open?
                      Likewise, you may add extra storage with closed cabinets
                      to keep things organised.
                    </p>{" "}
                  </li>

                  <li>
                    <h5>
                      <strong>Faucets and Hardware: </strong>
                    </h5>
                    <p>
                      For a modern style, look for faucets and other hardware
                      with sleek finishes. Think carefully about which finish
                      will match the other materials in your bathroom.
                    </p>
                  </li>

                  <li>
                    <h5>
                      <strong>Grouting and Maintenance: </strong>
                    </h5>
                    <p>
                      {`For a seamless look, pick a grout colour that matches your
                      tile colour. Don’t forget grout needs regular maintenance
                      to retain a fresh look. Besides, won't it make your life
                      easier if you choose easy-care tiles?`}
                    </p>
                  </li>
                </ul>
              </div>

              <div className="common-text-content-section">
                <h2> How Do I Decorate My Modern White Bathroom?</h2>
                <p>
                  To decorate a modern white bathroom, you must explore ideas
                  that can add personality and style to your bathing space. So,
                  here are some inspirations to upgrade your bathroom decor into
                  a relaxing, inviting haven.{" "}
                </p>
                <ul>
                  <li>
                    <h5>
                      <strong>Colour Scheme: </strong>
                    </h5>
                    <p>
                      Every modern white bathroom uses the white colour all
                      across but with some pops of colour. From dramatic black
                      to earthy tones, various colours can complement white
                      walls and fixtures. You can infuse tones like grey, beige,
                      black, and blue. Would you prefer a soft, relaxing look or
                      something more vibrant? Think about the colour scheme that
                      makes the overall ambience feel calm and peaceful.
                    </p>
                  </li>
                  <li>
                    <h5>
                      <strong>Add Patterns with Accessories: </strong>
                    </h5>
                    <p>
                      Combine various wall tile patterns to bring life to your
                      white bathroom. Patterns like geometric, floral, or mosaic
                      can add visual interest and texture. You can pair them
                      with various accessories to introduce fun and complement
                      the wall designs.
                    </p>
                  </li>
                  <li>
                    <h5>
                      <strong>Statement Bathroom Mirrors:</strong>
                    </h5>
                    <p>
                      Install a stylish bathroom mirror to create a focal point.
                      From round to rectangular shapes, every mirror can help
                      open up the space and add a touch of elegance.
                    </p>{" "}
                  </li>

                  <li>
                    <h5>
                      <strong>Decorate Wall Space Creatively: </strong>
                    </h5>
                    <p>
                      Combine different wall tile designs to create unique and
                      interesting wall designs. For example, combine colourful
                      tile patterns with white plain or marble tiles to create a
                      balanced and cohesive look. This idea is perfect for
                      creating an engaging wall design behind the bathtub or
                      sink.
                    </p>
                  </li>

                  <li>
                    <h5>
                      <strong>Follow Trends or Go Classic: </strong>
                    </h5>
                    <p>
                      Trending bathroom designs combine interesting tile
                      patterns, coupled with stylish fixtures. However, the
                      classic decors are inclined towards a timeless appeal. So,
                      will you go for a minimalist trend for your next bathroom
                      renovation? Or, do you want to create a classic design? Go
                      as you like it! You can always find tile designs that suit
                      your desired appearance.
                    </p>
                  </li>
                </ul>
              </div>
            </div>

            {/* <div className='designpage-faq-section padding-spacing'>
              <h2>FAQs About White Bathroom Design</h2>
              <div className="newacd designpage-faq-row">
                <ul className="accordion">
                  {displayedFAQs.map((faq, index) => (
                    <li key={index}>
                      <a className="toggle" onClick={() => handleToggle(index)}>
                        {index + 1}. {faq.question}
                      </a>
                      {activeIndex === index && (
                        <ul className="inner">
                          <li>{faq.answer}</li>
                        </ul>
                      )}
                    </li>
                  ))}
                </ul>
				{faqs.length > 5 && (
          <div className='tru_btn_new design-page'>
          <button
            className='btn btn-primary'
            onClick={() => setShowAll(!showAll)}
          >
            {showAll ? 'Show Less' : 'Read More'}
          </button>
          </div>
        )}
              </div>
            </div> */}

            {relatedBlogData?.length > 0 && (
              <div className="tile-related-blog">
                <h2 className="title">Related Blogs</h2>
                <div className="designpage-relatedpost-row">
                  <Slider {...settings}>
                    {relatedBlogData?.map((obj, index) => {
                      return (
                        <div className="related-blog-col" key={index}>
                          <div className="blog-figure">
                            <a href={obj.permalink}>
                              <img
                                src={obj.image}
                                loading="lazy"
                                alt="Marble Tiles Vs Marble Slab: What is Better for Your Home?"
                              />
                            </a>
                          </div>
                          <div className="blog-text">
                            <div className="listingDate">{obj.date}</div>
                            <div className="listingHead">
                              <a href={obj.permalink}>
                                <div
                                  dangerouslySetInnerHTML={{
                                    __html: obj.title,
                                  }}
                                />
                              </a>
                            </div>
                            <div className="listingText">
                              <p>
                                {" "}
                                <div
                                  dangerouslySetInnerHTML={{
                                    __html: obj.content.slice(0, -11),
                                  }}
                                />
                              </p>
                              <div className="listingButton">
                                <a href={obj.permalink}>Read More</a>
                              </div>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </Slider>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export default WhiteBathroom;
